<template>
<div class="center__div">
  <vue-headful :title="site_title + ': Новости'" />
  <template v-if="displayNews">
    <div class="news__news">Новости</div>
    <MainStickiedArticles />
  </template>

  <template v-for="item in items">
    <!-- DATE -->
    <div class="news__date" v-if="item.printDay">
      <div>{{item.longDate}}</div>
    </div>

    <!-- ARTICLE -->
    <div class="news__articletitle">
      <!-- ICON, NAME, AUTHOR, DATE -->

      <a :href="'?actions=news&category='+item.circle"> <img style="vertical-align: middle; padding-right: 5px;" :src="publicPath + 'div' + getCircleIcon(item.circle) +'.gif'"> </a>
      <a class="articlename" :href="'?actions=viewnews&page=' + item.id"> <span>{{htmlDecode(item.header)}}</span> </a> -
      <a :href="'mailto:'+item.email">{{htmlDecode(item.name)}}</a> |
      {{item.time | formatDateHours}}
    </div>
    <br>
    <!-- ARTICLE BODY -->
    <div class="article__body" v-html="fixRealmsMainPaths(item.news)"></div>
    <!--<div v-html="fixQuoteTags(fixVariousTags(fixRpgplanetLinks(fixSmileysPath(response.pm.post)), post))"></div>-->

    <!-- NUMBER OF COMMENTS -->
    <div class="news__commentlink">
      <a :href="'?actions=viewnews&page=' + item.id + '#comments'">Комментарии ({{item.ncomments}})</a>
    </div>
    <div class="news__separator"></div>
  </template>

  <!-- pagination -->
  <div class="news__date news__pages" v-if="pageReady">
    <div class="news__pagination">Страницы({{totalPages}}):</div>
    <div class="news__pagination" v-for="elem in pagination">
      <template v-if="elem.isLink && viewArhive">
        <a :href="'?actions=viewarhive&page='+elem.value">{{elem.value}}</a>
      </template>
      <template v-else-if="elem.isLink && articleCategory">
        <a :href="'?actions=news&category='+category+'&page='+elem.value">{{elem.value}}</a>
      </template>
      <template v-else>
        {{elem.value}}
      </template>
    </div>
  </div>

</div>
</template>

<script>
import MainStickiedArticles from './MainStickiedArticles'
//import FooterPermanent from './FooterPermanent'

export default {
  props: ['articleCategory', 'viewArhive'], // passed from Main.vue
  components: {
    MainStickiedArticles,
    //ForumSection,
    //FooterPermanent
  },
  data: function() {
    return {
      items: null,
      lastPrintedDay: null,
      pageReady: false,
      displayNews: false,
      totalPages: 0,
      currentPage: 0,
      category: 0,
      pagination: [],
    }
  },
  async created() {
    console.time("PageLoadTime");

    let response = null;

    // if we're displaying a certain category of news, either with a specified page or not
    // e.g. http://realms.test:8080/main/?actions=news&section=1&category=1
    // or   http://realms.test:8080/main/?actions=news&section=1&category=1&page=1
    if (this.articleCategory) {
      let page = 1;
      let category = 1;
      if (this.$route.query.page) {
        page = this.convertToInt(this.$route.query.page);
      }
      if (this.$route.query.ions) {
        category = this.convertToInt(this.$route.query.ions);
      }
      // prioritize "category" over "ions", whatever it is
      if (this.$route.query.category) {
        category = this.convertToInt(this.$route.query.category);
      }
      this.category = category;
      response = await fetch(this.getNodePath() + 'main/newscat/' + category + '/page/' + page);
    }
    // if we're displaying all categories of news, either with a specified page or just from /main/
    // e.g. http://realms.test:8080/main/?actions=viewarhive&page=1
    // or   http://realms.test:8080/main/
    else if (this.viewArhive) {
      let page = 1;
      if (this.$route.query.page) {
        page = this.convertToInt(this.$route.query.page);
      }
      response = await fetch(this.getNodePath() + 'main/' + page);
      this.displayNews = page == 1;
    }

    let data = await response.json();
    this.items = data.items;
    this.prep_items(this.items);
    this.totalPages = data.totalPages;
    this.currentPage = data.curPage;
    this.generatePagination();

    this.pageReady = true;
    console.timeEnd("PageLoadTime");
  },
  methods: {
    // date needs to be displayed only for the first article with that day, so we prep data by setting printDay
    prep_items(items) {
      let lastDay = null;
      items.forEach((item, i) => {
        item.longDate = this.$options.filters.formatRusDateLong2(item.time);
        if (!lastDay || lastDay != item.longDate) {
          item.printDay = true;
          lastDay = item.longDate;
        } else {
          item.printDay = false;
        }
      });
    },
    convertToInt(value) {
      // Check if value is not a number
      if (isNaN(value)) {
        return 1;
      } else {
        // Convert to integer if it's a number or a float
        return parseInt(value);
      }
    },
    generatePagination() {
      let currentPage = this.currentPage;
      let maxPage = this.totalPages;

      const range = 3;
      const result = [];

      // Add lowest page number if necessary
      if (currentPage - range > 1) {
        result.push({
          value: 1,
          isLink: true
        });
        result.push({
          value: "......",
          isLink: false
        });
      }

      // Add the 6 pages below the current page
      for (let i = Math.max(1, currentPage - range); i < currentPage; i++) {
        if (i > 0) {
          result.push({
            value: i,
            isLink: true
          });
        }
      }

      // Add the current page
      result.push({
        value: currentPage,
        isLink: false
      });

      // Add the 5 pages above the current page
      for (let i = currentPage + 1; i <= Math.min(maxPage, currentPage + range); i++) {
        result.push({
          value: i,
          isLink: true
        });
      }

      // Add the highest page number if necessary
      if (currentPage + range < maxPage) {
        result.push({
          value: "......",
          isLink: false
        });
        result.push({
          value: maxPage,
          isLink: true
        });
      }
      //console.log(result);

      this.pagination = result;
    }
  }
}
</script>

<style lang="scss">
@import "../main-colors.scss";
@import "./MainNews.scss";
</style>
